import clsx from 'clsx'
import React, { ReactElement } from 'react'
import Loading from '../Loading'

function Button({
  className,
  children,
  secondary,
  loading,
  ...otherProps
}: React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & { secondary?: boolean; loading?: boolean }): ReactElement {
  return (
    <button
      style={{ minWidth: 100 }}
      className={clsx(
        'focus:outline-none hover:opacity-75 disabled:opacity-50 items-center flex justify-center transition-opacity focus:opacity-85 rounded-full px-6 py-3 w-full text-app-primary font-openSans uppercase',
        { 'bg-denim text-white': secondary, 'bg-yellow': !secondary },
        className
      )}
      {...otherProps}
    >
      <span>{children}</span>
      {loading && <Loading className="ml-5" radius={25} />}
    </button>
  )
}

export default Button
